export const queryLatestJobAddressQuery = `query queryLatestJobLocation($employeeId: String!){
        employee(employeeId: $employeeId) {
            jobInformation {
                location {
                    postalCode
                }
            }
        },
    }`;
